import TablaDetalleAgrupada from '../../ComponentesGlobales/TablaDetalleAgrupada';
import { useStoreIngresos } from './useStoreIngresos';
import Mensaje from "sweetalert";
import {
  descargarPDFProducto,
  generarPDFsMultiples,
  normalizarProducto,
  descargarPDFMultiplesUnificado,
  mostrarPDFProductoEnVentana,
  mostrarPDFMultiplesEnVentana,
  procesarPDF
} from '../../utils/pdfGenerator';
import { OpcionesEtiqueta } from '../../utils/OpcionesEtiqueta';
import demo from "../../icons/pregunta.png";
import IngresosReporte from './IngresosReporte';
import moment from 'moment';
import { MensajeToastError, MensajeToastExito, MensajeToastInfo } from '../../componentes/FuncionesLocales';

export default function IngresosTab3({ FlechaAtras }) {
  const ListaDetalleGrilla = useStoreIngresos((state) => state.ListaDetalleGrilla);
  const Fecha = useStoreIngresos((state) => state.Fecha);

  // Función para generar PDF con QR de un solo producto
  const generarPDFProducto = async (producto, opcionesExtra = {}) => {
    try {
      const productoNormalizado = normalizarProducto(producto);
      
      await descargarPDFProducto(
        productoNormalizado,
        {
          titulo: 'Información del Producto - PISeun',
          mostrarFecha: true,
          ...opcionesExtra,     
        }
      );
      MensajeToastExito('PDF generado exitosamente');
    } catch (error) {
      MensajeToastError('Error al generar el PDF: ' + error.message);
    }
  };

  // Función para generar PDFs múltiples
  const generarPDFsSeleccionados = async (productos, opcionesExtra = {}) => {
    try {
      if (!productos || productos.length === 0) {
        MensajeToastError('No hay productos seleccionados para generar PDF');
        return;
      }
      MensajeToastInfo('Generando ' + productos.length + ' archivo(s) PDF...');
      const productosNormalizados = productos.map(p => normalizarProducto(p));
     
      const pdfs = await generarPDFsMultiples(
        productosNormalizados,
        {
          titulo: 'Productos - PISeun',
          mostrarFecha: true,
          ...opcionesExtra,    
        }
      );

      // Descargar cada PDF
      pdfs.forEach(({ pdf, nombre }) => {
        pdf.save(nombre);
      });
      MensajeToastExito(`Se generaron ${pdfs.length} archivos PDF exitosamente`);
    } catch (error) {
      MensajeToastError('Error al generar los PDFs: ' + error.message);
    }
  };


  // Función para generar PDF unificado
  const generarPDFUnificado = async (productos, opcionesExtra = {}) => {
    try {
      if (!productos || productos.length === 0) {
        MensajeToastError('No hay productos seleccionados para generar PDF');
        return;
      }
      MensajeToastInfo('Generando PDF unificado con ' + productos.length + ' producto(s)...');
      const productosNormalizados = productos.map(p => normalizarProducto(p));
     await descargarPDFMultiplesUnificado(
        productosNormalizados,
        {
          titulo: 'Listado de Productos - PISeun',
          mostrarFecha: true,
          productosPorPagina: 2,
          numerarProductos: true,
          encabezado: 'Reporte generado desde Ingresos - Sistema PISeun',
          ...opcionesExtra,   
        }
      );
      MensajeToastExito(`Documento único con ${productos.length} producto(s) descargado exitosamente`);

    } catch (error) {
      MensajeToastError('Error al generar el PDF unificado: ' + error.message);
    }
  };

  const handlePrint = async (nivel, { records }) => {
    try {
      // Primero preguntar si quiere ver en ventana emergente o descargar
      const vistaOpcion = await new Promise((resolve) => {
        Mensaje({
          title: "¿Cómo deseas ver el PDF?",
          text: `${records.length} producto(s) seleccionado(s)`,
          icon: "info",
          buttons: {
            ventana: { text: "🔍 Ver en Ventana", value: "ventana", className: "btn-primary" },
            descargar: { text: "⬇️ Descargar", value: "descargar", className: "btn-success" },
            cancel: { text: "Cancelar", value: null, className: "btn-secondary" }
          }
        }).then(resolve);
      });

      if (!vistaOpcion) return; // Cancelado

      let opcionesPDF;
      try {
        opcionesPDF = await OpcionesEtiqueta(records.length);
      } catch (e) {
        // cancelado o inválido → no sigo
        return;
      }


      if (records.length === 1) {
        // Un solo registro
        if (vistaOpcion === "ventana") {
          await mostrarPDFProductoEnVentana(records[0], opcionesPDF);
        } else {
          await generarPDFProducto(records[0], opcionesPDF);
        }
      } else {
        // Múltiples registros - mostrar opciones de formato

        if (vistaOpcion !== "ventana") {
          const formatoOpcion = await new Promise((resolve) => {
            Mensaje({
              title: "¿Cómo deseas generar los documentos?",
              text: `${records.length} productos seleccionados`,
              icon: "info",
              buttons: {
                unificado: {
                  text: "📑 PDF Unificado",
                  value: "unificado",
                  className: "btn-success"
                },
                separados: {
                  text: "📚 PDFs Separados",
                  value: "separados",
                  className: "btn-info"
                },
                cancel: {
                  text: "Cancelar",
                  value: null,
                  className: "btn-secondary"
                }
              }
            }).then(resolve);
          });

          if (!formatoOpcion) return; // Cancelado

          if (formatoOpcion === "unificado") {
            if (vistaOpcion === "ventana") {

              await mostrarPDFMultiplesEnVentana(records, opcionesPDF);
            } else {

              await generarPDFUnificado(records, opcionesPDF);
            }
          } else if (formatoOpcion === "separados") {
            // Para PDFs separados, solo opción de descarga por ahora
            if (vistaOpcion === "ventana") {
              MensajeToastInfo('Vista en ventana no disponible para PDFs separados. Se procederá con la descarga.');
            }
            await generarPDFsSeleccionados(records, opcionesPDF);
          }
        }
        else {
          const productosNormalizados = records.map(p => normalizarProducto(p));
          await mostrarPDFMultiplesEnVentana(productosNormalizados, opcionesPDF);
        }
      }
    } catch (error) {
      MensajeToastError('Error al procesar la solicitud: ' + error.message);
    }
  };


  return (
    <div className="ing-registros">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h3 className="ing-subtitulo">
          Detalles de Registros
        </h3>
        <IngresosReporte />
      </div>

      <div className="ing-detalle">
        <div className="detalle-registros">
          <TablaDetalleAgrupada
            lista={ListaDetalleGrilla}
            mapToPayload={(r) => r.IdentificadorId}
            onDelete={(tipo, { payload, remito }) => {
              const titulo = tipo === "Remito"
                ? `¿Está seguro de eliminar el remito ${remito}?`
                : `¿Está seguro de eliminar los registros seleccionados?`;
              Mensaje({
                title: titulo,
                icon: demo,
                buttons: ["Cancelar", "Aceptar"],
                dangerMode: true,
              }).then((ok) => {
                if (!ok) return;
                useStoreIngresos.setState({ Seleccionados: payload });
                useStoreIngresos.getState().eliminarSeleccionados();
              });
            }}
            onPrint={handlePrint}
          />
        </div>
      </div>
    </div>
  )
}
